import { BookOpen, Clock, FileBadge, NotebookPen, PlusCircle, Trash, User } from "lucide-react";
import React, { useEffect, useImperativeHandle, useRef, useState } from "react";
import axios from '../../axios'
import { NavLink, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import assets from "../../assets/assets";
import { Calendar, SquareChartGantt } from "lucide-react";
import SharedFiles from "./SharedFiles";
import { format } from "date-fns";
import SummaryUpdated from "./SummaryUpdated/SummaryUpdated";
import AssessmentViewClickPopup from "../../DcmDetails/Summary/SummaryUpdated/AssessmentViewClickPopup";
import JoinNowbtn from "./PopUp/buttons/JoinNowbtn";
import StudyPlannerPop from "./PopUp/Science/StudyPlannerPop";


function SummaryLectureUi({ event, handleCloseSummaryPopup, handleClick, scheduleRef }) {

    const {
        lectureName,
        StartTime,
        EndTime,
        Events,
        Supplement_id,
        LectureInstruction = "",
        LectureSummary = "",
    } = event;
    const [summary, setSummary] = useState(false);
    const [activity, setActivity] = useState([]);
    const [homework, setHomework] = useState([]);
    const [preRead, setPreRead] = useState([]);
    const [assessment, setAssessment] = useState([]);
    const [assClick, setAssClick] = useState(false);
    const [assessmentData, setAssessmentData] = useState(null)
    const [isOpenPopUp, isSetOpenPopUp] = useState(false)

    const currentUser = useSelector((state) => state.user.currentUser);

    const [status, setStatus] = useState({
        assessment: "",
        preRead: "",
        activity: "",
        homework: "",
    });

    const handleClose = () => {
        scheduleRef?.closeQuickInfoPopup();
    };
    const navigate = useNavigate();

    const currentTime = new Date();

    // determines if event is after currently happening based on current time
    const isHappened = currentTime.getTime() > event?.EndTime?.getTime();

    // determines if event is currently happening based on current time
    const isEventHappening =
        currentTime.getTime() >= event?.StartTime?.getTime() &&
        currentTime.getTime() <= event?.EndTime?.getTime();

    // determines if event is before currently happening based on current time
    const isUpcoming = currentTime.getTime() < event?.StartTime?.getTime();

    const onJoinNowClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
    };

    const timeDiff = (timeStart, timeEnd) => {
        var time1 = timeStart;
        var time2 = timeEnd;
        // Convert the time strings to Date objects
        var date1 = new Date(time1);
        var date2 = new Date(time2);

        // Calculate the difference in milliseconds between the two times
        var diffInMs = date2.getTime() - date1.getTime();

        // Convert the difference in milliseconds to minutes, assuming 1 minute = 60000 ms
        var diffInMins = diffInMs / 60000;
        return diffInMins;
    };

    const formatTime = (dateStr) =>
        new Date(dateStr).toLocaleTimeString("en-IN", {
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
        });
    const formatDate = (dateStr) =>
        new Date(dateStr).toLocaleDateString("en-IN", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
        });

    useEffect(() => {
        const handleSupplementDetails = async () => {
            // Ensure that 'event?.Events' exists and is an array
            if (!event?.Events || !Array.isArray(event.Events)) {
                return;
            }

            for (const obj of event.Events) {

                if (obj.name === "activity") {
                    try {
                        const res = await axios.get(`/homework/activity/getById/${obj.value}`);
                        if (res && res.data && res.data.data) {
                            setActivity(res.data.data);
                        }
                    } catch (error) {
                        setAssessmentData(error.response.data.message)
                        console.error("Error fetching activity:", error);
                    }
                }

                if (obj.name === "pre_read") {
                    try {
                        const res = await axios.get(`/homework/preRead/getById/${obj.value}`);
                        if (res && res.data && res.data.data) {
                            setPreRead(res.data.data);
                        }
                    } catch (error) {
                        setAssessmentData(error.response.data.message)
                        console.error("Error fetching pre-read:", error);
                    }
                }

                if (obj.name === "assessment") {
                    try {
                        const res = await axios.get(`/assessment/getForStudent/${obj?.value}`);
                        if (res && res.data && res.data.data) {
                            setAssessment(res.data.data);
                        }
                    } catch (error) {
                        setAssessmentData(error.response.data.message)
                        console.error("Error fetching assessment:", error);
                    }
                }

                if (obj.name === "homework") {
                    try {
                        const res = await axios.get(`/homework/get/${obj.value}`);
                        if (res && res.data && res.data.data) {
                            setHomework(res.data.data);
                        }
                    } catch (error) {
                        setAssessmentData(error.response.data.message)
                        console.error("Error fetching homework:", error);
                    }
                }
            }
        };
        handleSupplementDetails();
    }, [event]);

    useEffect(() => {
        const handleSupplementDetails = async () => {
            // Ensure that 'event?.Events' exists and is an array
            if (!event?.Events || !Array.isArray(event.Events)) {
                return;
            }

            for (const obj of event.Events) {

                if (obj.name === "activity") {
                    try {
                        const res = await axios.get(`/homework/activity/getById/${obj.value}`);
                        if (res && res.data && res.data.data) {
                            setActivity(res.data.data);
                        }
                    } catch (error) {
                        setAssessmentData(error.response.data.message)
                        console.error("Error fetching activity:", error);
                    }
                }

                if (obj.name === "pre_read") {
                    try {
                        const res = await axios.get(`/homework/preRead/getById/${obj.value}`);
                        if (res && res.data && res.data.data) {
                            setPreRead(res.data.data);
                        }
                    } catch (error) {
                        setAssessmentData(error.response.data.message)
                        console.error("Error fetching pre-read:", error);
                    }
                }

                if (obj.name === "assessment") {
                    try {
                        const res = await axios.get(`/assessment/getForStudent/${obj?.value}`);
                        if (res && res.data && res.data.data) {
                            setAssessment(res.data.data);
                        }
                    } catch (error) {
                        setAssessmentData(error.response.data.message)
                        console.error("Error fetching assessment:", error);
                    }
                }

                if (obj.name === "homework") {
                    try {
                        const res = await axios.get(`/homework/get/${obj.value}`);
                        if (res && res.data && res.data.data) {
                            setHomework(res.data.data);
                        }
                    } catch (error) {
                        setAssessmentData(error.response.data.message)
                        console.error("Error fetching homework:", error);
                    }
                }
            }
        };
        handleSupplementDetails();
    }, [event]);

    useEffect(() => {
        const fetchData = async () => {
            try {

                const resources = [
                    {
                        type: "assessment",
                        id: assessment?.id,
                        setStatusKey: "assessment",
                    },
                    {
                        type: "preRead",
                        id: preRead?.id,
                        setStatusKey: "preRead",
                    },
                    {
                        type: "activity",
                        id: activity?.id,
                        setStatusKey: "activity",
                    },
                    {
                        type: "homework",
                        id: homework?.id,
                        setStatusKey: "homework",
                    },
                ];

                for (const resource of resources) {
                    if (resource.id) {
                        const response = await axios.get(
                            `/${resource.type}/studentStatus/${resource.type}Id/${resource.id}/studentId/${currentUser?.id}`
                        );
                        setStatus((prevStatuses) => ({
                            ...prevStatuses,
                            [resource.setStatusKey]: response.data.data.status,
                        }));
                    }
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            }

            console.log(status);
        };

        fetchData();
    }, [assessment, homework, activity, preRead, currentUser]);

    //assessment function to return based on status
    function getRRoutefromStatus(status, assessmentId) {
        console.log("status", status);
        console.log("assessmentId", assessmentId);

        let url;
        switch (status) {
            case "completed":
                url = `/Assessment/completed`;
                break;
            case "pending":
                // url = `/Assessment/pending/questions/${assessmentId}`;
                setAssClick(true);
                return;
            case "review":
                url = `/Assessment/review/questions`;
                break;
            default:
                url = "/Calender";
        }
        navigate(url, { state: { assessmentId: assessmentId } });
        return;
    }

    function getRRoutefromStatusPreRead(status, id) {
        console.log("status", status);
        console.log("pre read id", id);

        let url;
        switch (status) {
            case "completed":
                url = `/presRead/completed`;
                break;
            case "pending":
                url = `/preReads/published`;
                break;
            default:
                url = "/Calender";
                break;
        }

        navigate(url, { state: { preReadId: id } });
        return;
    }

    function getRRoutefromStatusActivity(status, id) {
        let url;
        switch (status) {
            case "completed":
                url = `/completedActivity`;
                break;
            case "pending":
                url = `/publishedActivity`;
                break;
            case "review":
                url = `/reviewActivity`;
                break;
            default:
                url = "/Calender";
                break;
        }
        navigate(url, { state: { activityId: id } });
        return;
    }

    function getRRoutefromStatusHomework(status, id) {
        let url;
        switch (status) {
            case "completed":
                url = `/completedHomework`;
                break;
            case "pending":
                url = `/publishedHomework`;
                break;
            case "review":
                url = `/reviewHomework`;
                break;
            default:
                url = "/Calender";
                break;
        }
        navigate(url, { state: { homeworkId: id } });
        return;
    }
    const eventDataMap = Object.fromEntries(
        (Events || []).map(({ name, value }) => [name, value])
    );
    const supplementCount = [
        eventDataMap.assessment,
        eventDataMap.pre_read,
        eventDataMap.homework,
        eventDataMap.activity,
    ].filter(Boolean).length;


    const getDurationString = (startTime, endTime) => {
        const start = new Date(startTime);
        const end = new Date(endTime);

        const diffMs = end - start;
        const totalMinutes = diffMs / (1000 * 60);
        const hours = Math.floor(totalMinutes / 60);
        const minutes = totalMinutes % 60;

        return `${hours > 0 ? `${hours} Hr${hours > 1 ? "s" : ""}` : ""}${minutes > 0 ? ` ${minutes} Min${minutes > 1 ? "s" : ""}` : ""
            }`.trim();
    };




    return (
        <div
        // className="orange-scrollBar"
        // style={{ overflowY: "scroll", maxHeight: "450px" }}
        >
            <div className="d-flex justify-content-end gap-2 mb-2">
                {
                    <>
                        <button
                            type="button"
                            className="btn btn-sm  d-flex align-items-center"
                            data-bs-toggle="tooltip"
                            data-bs-placement="top"
                            title="Add Supplement"
                        >
                            {(isHappened && event.Events[0] !== "Planner") && event?.SupplementId === undefined ? "" : isUpcoming && event?.SupplementId === undefined ? "" : (isHappened && event.Events[0] === "Planner") && event?.SupplementId === undefined ? "" : <SquareChartGantt size={20} onClick={() => setSummary(true)} />}
                        </button>
                    </>
                }

                <button
                    type="button"
                    className="btn btn-sm  rounded-2 border-2 fw-bold"
                    title="Close"
                    onClick={handleClose}
                >
                    <img src={assets.CrossIcon} width="23px" height="23px" alt="crossicon" />
                </button>
            </div>
            <div className=" rounded-4 p-1 poppins-semibold ">
                <div className=" poppins-semibold ">
                    {/* Header */}
                    <div
                        className="mb-3 p-2 rounded-2"
                        style={{ backgroundColor: "#ffebd3", width: "100%" }}
                    >
                        <h5 className="poppins-semibold  ">
                            {lectureName || event.Subject}
                        </h5>
                        <div className="flex flex-wrap gap-3 text-muted small mt-2 poppins-semibold ">
                            <span className="flex justify-center items-center">
                                <Calendar size={16} className="me-1" /> {formatDate(StartTime)}
                            </span>
                            <span className="flex justify-center items-center">
                                <Clock size={16} className="me-1" /> {formatTime(StartTime)}
                            </span>
                            <div className="flex gap-3 justify-start">
                                {((isHappened && event.Events[0] === "Planner") || isUpcoming && event.Events[0] === "Planner") ? null : <span className="flex items-center w-24">
                                    <User size={16} className="me-1" />{" "}
                                    {event?.Teacher?.name || "Teacher Name"}
                                </span>}
                                <span className="flex items-center  w-16">
                                    <Clock size={16} className="me-1" />
                                    {getDurationString(StartTime, EndTime)}
                                </span>

                                {((isHappened && event.Events[0] === "Planner") || isUpcoming && event.Events[0] === "Planner") ? null : <span className="flex items-center w-24">
                                    <FileBadge size={16} className="me-1" /> Lecture Supplement(
                                    {supplementCount})
                                </span>}
                            </div>
                        </div>
                    </div>

                    <div className="orange-scrollBar"
                        style={{ overflowY: "scroll", maxHeight: "220px" }}
                    >
                        {Events && Events.length === 0 ? (
                            <div>{""}</div>
                        ) : (
                            <>
                                {/* Lecture Instruction */}
                                {((isHappened && event.Events[0] === "Planner") || isUpcoming && event.Events[0] === "Planner")
                                    ? (<>
                                        {event.name === "" ||
                                            !event.name ? (
                                            ""
                                        ) : (
                                            <div className="bg-light rounded p-3 mb-2 d-flex align-items-start"

                                            >
                                                <BookOpen size={20} className="me-2 flex-shrink-0" />
                                                <div className="px-1">
                                                    <h6 className="poppins-semibold  mb-1">
                                                        Study Planner Name
                                                    </h6>
                                                    <p
                                                        className="text-muted small  mb-0 poppins-semibold "
                                                        style={{
                                                            display: "-webkit-box",
                                                            WebkitBoxOrient: "vertical",
                                                            WebkitLineClamp: 7,
                                                            overflow: "hidden",
                                                            textOverflow: "ellipsis",
                                                            wordBreak: "break-word",
                                                            overflowWrap: "break-word",
                                                        }}
                                                    >
                                                        {event.name ? event.name : 'No Name Available!'}
                                                    </p>
                                                </div>
                                            </div>
                                        )}
                                    </>)
                                    : (<>
                                        {eventDataMap.lecInstruction === "" ||
                                            !eventDataMap.lecInstruction ? (
                                            ""
                                        ) : (
                                            <div className="bg-light rounded p-3 mb-2 d-flex align-items-start"

                                            >
                                                <BookOpen size={20} className="me-2 flex-shrink-0" />
                                                <div className="px-1">
                                                    <h6 className="poppins-semibold  mb-1">
                                                        Lecture Instruction
                                                    </h6>
                                                    <p
                                                        className="text-muted small  mb-0 poppins-semibold "
                                                        style={{
                                                            display: "-webkit-box",
                                                            WebkitBoxOrient: "vertical",
                                                            WebkitLineClamp: 7,
                                                            overflow: "hidden",
                                                            textOverflow: "ellipsis",
                                                            wordBreak: "break-word",
                                                            overflowWrap: "break-word",
                                                        }}
                                                    >
                                                        {eventDataMap.lecInstruction ? eventDataMap.lecInstruction : 'No Instruction Available!'}
                                                    </p>
                                                </div>
                                            </div>
                                        )}
                                    </>)

                                }

                                {/* Lecture Summary */}
                                {((isHappened && event.Events[0] === "Planner") || isUpcoming && event.Events[0] === "Planner")
                                    ? (<>
                                        {event.description === "" || !event.description ? (
                                            " "
                                        ) : (
                                            <div className="bg-light rounded p-3 mb-2 d-flex flex-row">
                                                <NotebookPen size={18} className="me-2 flex-shrink-0" />
                                                <div className="">
                                                    <h6 className=" mb-2 d-flex align-items-center poppins-semibold ">
                                                        Study Planner Description
                                                    </h6>
                                                    <p
                                                        className="text-muted small mb-0 poppins-semibold "
                                                        style={{
                                                            display: "-webkit-box",
                                                            WebkitBoxOrient: "vertical",
                                                            WebkitLineClamp: 7,
                                                            overflow: "hidden",
                                                            textOverflow: "ellipsis",
                                                            wordBreak: "break-word",
                                                            overflowWrap: "break-word",
                                                        }}
                                                    >
                                                        {event.description ? event.description : "No Description Available!"}
                                                    </p>
                                                </div>
                                            </div>
                                        )}
                                    </>)
                                    : (<>
                                        {eventDataMap.description === "" || !eventDataMap.description ? (
                                            " "
                                        ) : (
                                            <div className="bg-light rounded p-3 mb-2 d-flex flex-row">
                                                <NotebookPen size={18} className="me-2 flex-shrink-0" />
                                                <div className="">
                                                    <h6 className=" mb-2 d-flex align-items-center poppins-semibold ">
                                                        Lecture Summary
                                                    </h6>
                                                    <p
                                                        className="text-muted small mb-0 poppins-semibold "
                                                        style={{
                                                            display: "-webkit-box",
                                                            WebkitBoxOrient: "vertical",
                                                            WebkitLineClamp: 7,
                                                            overflow: "hidden",
                                                            textOverflow: "ellipsis",
                                                            wordBreak: "break-word",
                                                            overflowWrap: "break-word",
                                                        }}
                                                    >
                                                        {eventDataMap.description ? eventDataMap.description : "No Description Available!"}
                                                    </p>
                                                </div>
                                            </div>
                                        )}
                                    </>)}


                                {/* Shared Files */}
                                {eventDataMap.attachments &&
                                    eventDataMap.attachments.length > 0 ? (
                                    <div className="bg-light rounded p-3 mb-2 d-flex flex-row">
                                        <SharedFiles attachments={eventDataMap.attachments} />
                                    </div>
                                ) : (
                                    ""
                                )}
                                {/* {console.log("event=>>>>>>>>>>>>>>>>>", event)}; */}

                                {/* Lecture Supplements */}
                                {((isHappened && event.Events[0] === "Planner") || isUpcoming && event.Events[0] === "Planner") ? null : <div className="bg-light rounded p-3 mb-2">
                                    <h6 className="fw-semibold mb-3">📚 Lecture Supplements</h6>
                                    <div className=" d-flex align-items-center justify-content-around text-center">
                                        {eventDataMap.assessment && (
                                            <div onClick={localStorage.setItem("from", "DCM")}>
                                                <NavLink
                                                    onClick={() => getRRoutefromStatus(
                                                        status.assessment,
                                                        assessment?.id
                                                    )}
                                                >
                                                    <img
                                                        src="/DCM-img/assessment.svg"
                                                        alt=""
                                                        style={{
                                                            width: "26px",
                                                            height: "26px",
                                                            objectFit: "contain",
                                                            margin: "auto"
                                                        }}
                                                        onClick={() => {
                                                            if (assessmentData !== null) {
                                                                isSetOpenPopUp(true)
                                                            }
                                                        }}
                                                    />
                                                </NavLink>
                                                <div className="small mt-1 poppins-semibold ">
                                                    Assessment
                                                </div>
                                            </div>
                                        )}

                                        {eventDataMap.pre_read && (
                                            <div onClick={localStorage.setItem("from", "DCM")}>
                                                <div>
                                                    <img
                                                        src="/DCM-img/preread.svg"
                                                        alt=""
                                                        className="icns cursor-pointer"
                                                        style={{
                                                            width: "24px",
                                                            height: "24px",
                                                            objectFit: "contain",
                                                            margin: "auto"
                                                        }}
                                                        onClick={() => getRRoutefromStatusPreRead(
                                                            status.preRead,
                                                            preRead?.id
                                                        )}
                                                    />
                                                </div>
                                                <div className="small mt-1 poppins-semibold ">
                                                    Pre-Read
                                                </div>
                                            </div>
                                        )}

                                        {eventDataMap.homework && (
                                            <div onClick={localStorage.setItem("from", "DCM")}>
                                                <img
                                                    src="/DCM-img/homework.svg"
                                                    alt=""
                                                    className="icns"
                                                    style={{
                                                        width: "24px",
                                                        height: "24px",
                                                        objectFit: "contain",
                                                        margin: "auto"
                                                    }}
                                                    onClick={() =>
                                                        getRRoutefromStatusHomework(
                                                            status.homework,
                                                            homework?.id
                                                        )
                                                    }
                                                />
                                                <div className="small mt-1 poppins-semibold ">
                                                    Homework
                                                </div>
                                            </div>
                                        )}

                                        {eventDataMap.activity && (
                                            <div onClick={localStorage.setItem("from", "DCM")}>
                                                <img
                                                    src="/DCM-img/activity.svg"
                                                    alt=""
                                                    className="icns"
                                                    style={{
                                                        width: "24px",
                                                        height: "24px",
                                                        objectFit: "contain",
                                                        margin: "auto"
                                                    }}
                                                    onClick={() => {
                                                        getRRoutefromStatusActivity(
                                                            status.activity,
                                                            activity?.id
                                                        );
                                                    }}
                                                />
                                                <div className="small mt-1 poppins-semibold ">
                                                    Activity
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>}
                            </>
                        )}
                    </div>
                </div>
            </div>
            {summary && <SummaryUpdated assessmentId={assessment?.id} setCloseSummaryPopup={setSummary} data={event} />}
            {assClick && <AssessmentViewClickPopup setAssClick={setAssClick} />}
            {
                isEventHappening &&
                event.Events.some((item) => item.name === "bbb_lecture") && (
                    <JoinNowbtn event={event} />
                )
            }
            {isOpenPopUp && <StudyPlannerPop isSetOpenPopUp={isSetOpenPopUp} assessmentData={assessmentData} setAssessmentData={setAssessmentData} />}
        </div >
    );
}

export default SummaryLectureUi;
